import type { ReactNode } from 'react';
import React from 'react';

import { Paper, Typography } from '@mui/material';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  paper: {
    backgroundColor: theme.palette.common.white,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    height: 'fit-content',
    padding: theme.spacing(2),
    width: 800,
  },
  paperHeader: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(1),
  },
  paperHeaderDivider: {
    borderBottom: `1px solid ${theme.appColors.rule}`,
  },
}));

export function StepLayout({
  action,
  children,
  className,
  divider,
  title,
}: {
  children: ReactNode;
  title: ReactNode;
  /** Sits at the right end of the header row. */
  action?: ReactNode;
  className?: string;
  divider?: boolean;
}) {
  const { classes } = useStyles();

  return (
    <Paper className={clsx(classes.paper, className)}>
      <div className={clsx(classes.paperHeader, divider && classes.paperHeaderDivider)}>
        <Typography variant="subtitle1">{title}</Typography>
        {action}
      </div>
      {children}
    </Paper>
  );
}
